import { render, staticRenderFns } from "./NoAccountLinked.vue?vue&type=template&id=79f069b5&scoped=true&"
import script from "./NoAccountLinked.vue?vue&type=script&lang=js&"
export * from "./NoAccountLinked.vue?vue&type=script&lang=js&"
import style0 from "./NoAccountLinked.vue?vue&type=style&index=0&id=79f069b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f069b5",
  null
  
)

export default component.exports